import { render, staticRenderFns } from "./objective-card.vue?vue&type=template&id=733dd98c&"
import script from "./objective-card.vue?vue&type=script&lang=js&"
export * from "./objective-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports